<template>
  <div>
    <div class="content-bottom-padded">

    </div>
    <div>
      <el-row :gutter="20">
        <el-col :md="10" :lg="7">
          <el-input placeholder="商品名称" size="small" v-model="params.keywords"><el-button slot="append" icon="el-icon-search" @click="goodsSearch2"></el-button></el-input>
        </el-col>
        <el-col :md="10" :lg="7">
          <el-input placeholder="商品编号" size="small" v-model="params.item_bn"><el-button slot="append" icon="el-icon-search" @click="goodsSearch2"></el-button></el-input>
        </el-col>
        <el-col :md="10" :lg="7">
          <el-input placeholder="店铺id" size="small" v-model="vipparams.vip_distributor_number"><el-button slot="append" icon="el-icon-search" @click="goodsSearch2"></el-button></el-input>
        </el-col>

      </el-row>

      <el-tabs v-model="activeName" type="border-card" @tab-click="handleClick">
        <el-tab-pane  label="全部商品" name="first">

          <el-table :data="ItemsList" style="width: 100%" @selection-change="handleSelectionChange" :height="wheight-330" v-loading="loading">

            <el-table-column label="操作" width="" fixed>
              <template slot-scope="scope">
                <el-button type="text" @click="handleBatchStore(scope.row)" class="btn-gap">添加到vip优惠商品列表中</el-button>
              </template>
            </el-table-column>
            <el-table-column label="缩略图" width="" fixed>
              <template slot-scope="scope">
                <el-popover
                        placement="right"
                        width="240"
                        trigger="hover" >
                  <img  :src="wximageurl + scope.row.pics[0]" style="width:100%;">
                  <el-button type="text" slot="reference"><img style="width:50px;height:50px;" :src="wximageurl + scope.row.pics[0]" ></el-button>
                </el-popover>
              </template>
            </el-table-column>

            <el-table-column prop="goods_id" label="商品ID" width="">
              <template slot-scope="scope">
                默认ID:{{scope.row.goods_id}}<br/>
                当前ID:{{scope.row.item_id}}
              </template>
            </el-table-column>

            <el-table-column prop="item_bn" label="商品货号" width="">
              <template slot-scope="scope">
                {{scope.row.item_bn}}
              </template>
            </el-table-column>

            <el-table-column label="规格" width="">
              <template slot-scope="scope">
                <el-tag size="mini" effect="plain" type="success" v-if="!scope.row.nospec">多规格</el-tag>
                <el-tag size="mini" effect="plain" v-else>单规格</el-tag>
              </template>
            </el-table-column>
            <el-table-column prop="itemName" label="商品名称">
              <template slot-scope="scope">
                {{scope.row.item_name}}
              </template>
            </el-table-column>
            <el-table-column prop="market_price" label="原价">
              <template slot-scope="scope">
                ￥{{scope.row.market_price/100}}
              </template>
            </el-table-column>
            <el-table-column prop="price" label="商品价格">
              <template slot-scope="scope" >
                ￥{{scope.row.price}}
              </template>
            </el-table-column>

          </el-table>
          <div class="content-center content-top-padded">
            <el-pagination
                    background
                    layout="total, sizes, prev, pager, next"
                    @current-change="handleCurrentChange"
                    @size-change="handleSizeChange"
                    :current-page.sync="params.page"
                    :page-sizes="[10,20,50,100,200]"
                    :total="total_count"
                    :page-size="params.pageSize">
            </el-pagination>
          </div>
        </el-tab-pane>

        <el-tab-pane label="vip优惠商品" name="second">
          <el-table :data="vipItemList" style="width: 100%" @selection-change="handleSelectionChange" :height="wheight-330" v-loading="loading">

            <el-table-column prop="goods_id" label="商品ID" width="">
              <template slot-scope="scope">
                {{scope.row.item_id}}
              </template>
            </el-table-column>

            <el-table-column prop="item_bn" label="商品货号" width="">

            </el-table-column>

            <el-table-column prop="item_name" label="商品名称">

            </el-table-column>

            <el-table-column prop="vip_price" label="vip价格">
              <template slot-scope="scope">
                <el-input v-model="scope.row.vip_price" @change="editVipprice(scope.row)" size="mini"></el-input>
              </template>
            </el-table-column>
            <el-table-column prop="number" label="店铺id">

            </el-table-column>
            <el-table-column prop="name" label="店铺名">

            </el-table-column>
            <!--<el-table-column prop="sale_flag" label="状态">-->
              <!--<template slot-scope="scope" >-->
                <!--<span v-if="scope.row.sale_flag == '1'">开启</span>-->
                <!--<span v-if="scope.row.sale_flag == '0'">关闭</span>-->
              <!--</template>-->
            <!--</el-table-column>-->

            <!--<el-table-column label="操作" width="" >-->
              <!--<template slot-scope="scope">-->
                <!--<el-button type="text" @click="handleBatchStore(scope.row)" class="btn-gap"></el-button>-->
              <!--</template>-->
            <!--</el-table-column>-->
          </el-table>
          <div class="content-center content-top-padded">
            <el-pagination
                    background
                    layout="total, sizes, prev, pager, next"
                    @current-change="handleCurrentChangeVip"
                    @size-change="handleSizeChange"
                    :current-page.sync="vipparams.page"
                    :page-sizes="[10,20,50,100,200]"
                    :total="viptotal_count"
                    :page-size="vipparams.pageSize">
            </el-pagination>
          </div>
        </el-tab-pane>
      </el-tabs>

      <!-- 商品批量同步到店铺vip列  -->
      <SideBar :visible.sync="show_batchStore" title="商品批量添加到vip优惠" width="60">
        <div class="content-bottom-padded">
          <el-alert type="info" title="编辑提示" show-icon >
            <div>
              目前只针对怡康自营店设置VIP 价格<br/>
              如果输入店铺id(英克id)则店铺类型和区域类型无效。<br>
              店铺类型和店铺区域不能同时选择<br>
              店铺区域属于怡康自营门店和第三方门店无关 目前区域数据河北数据正常，其他区域数据无维护可能不准确<br>
              建议使用店铺英克id来进行批量操作
            </div>
          </el-alert>
        </div>
        <el-form label-position="left">
          <el-form-item label="商品id：">
            <el-row :gutter="10">
              <el-col :span="10">
                {{current}}
              </el-col>
            </el-row>
          </el-form-item>
          <el-form-item label="商品bn：">
            <el-row :gutter="10">
              <el-col :span="10">
                {{currentbn}}
              </el-col>
            </el-row>
          </el-form-item>
          <el-form-item label="商品价格：">
            <el-row :gutter="10">
              <el-col :span="10">
                ¥{{current_goods_price}}
              </el-col>
            </el-row>
          </el-form-item>
          <el-form-item label="Vip优惠价格：">
            <el-row :gutter="10">
              <el-col :span="10">
                <el-input :min="0" v-model="vipnowprice" :maxlength="30" placeholder="Vip优惠价格">
                  <i slot="suffix" class="el-input__icon el-icon-edit"></i>
                </el-input>
              </el-col>
            </el-row>
          </el-form-item>
          <el-form-item label="店铺类型： ">
            <el-row :gutter="10">
              <el-col :span="10">
                <el-select v-model="default_shop_type_value"   placeholder="选择店铺类型" style="width: 100%;">
                  <el-option
                          v-for="shop in shop_type_list_default"
                          :key="shop.value"
                          :label="shop.label"
                          :value="shop.value">
                  </el-option>

                </el-select>
              </el-col>
            </el-row>
          </el-form-item>
          <el-form-item label="区域分类">
            <el-row :gutter="10">
              <el-col :span="10">
                <el-cascader placeholder="所属大区" @change="handleOfficeChange"
                             :options="new_office_area"
                             :props="{ checkStrictly: true }"
                             clearable>
                </el-cascader>
              </el-col>
            </el-row>
          </el-form-item>


          <el-form-item label="店铺id(多个店铺用英文逗号隔开)： ">
            <el-row :gutter="10">
              <el-col :span="10">
                <el-input type="textarea" v-model="districtId" placeholder="请填写店铺id"></el-input>
              </el-col>
            </el-row>
          </el-form-item>
          <el-form-item   style="margin:0 50%">
            <el-row :gutter="10">
              <el-col :span="10">
                <el-button type="primary" @click="saveSynscVipPrice" :loading="submitLoading">保存</el-button>
              </el-col>
            </el-row>
          </el-form-item>
        </el-form>

      </SideBar>
      <el-dialog
              title="批量修改库存"
              :visible.sync="storeUpdate"
              width="30%">
        统一库存：<el-input v-model="itemstore" size="mini" type="number"></el-input>
        <span slot="footer" class="dialog-footer">
          <el-button @click="storeUpdate = false">取 消</el-button>
          <el-button type="primary" @click="saveItemsStore">确 定</el-button>
        </span>
      </el-dialog>


    </div>
    <router-view></router-view>
  </div>
</template>
<script>
    import { mapGetters } from 'vuex'
    import { getPopularizeSetting } from '@/api/promotions'
    // import the component
    import Treeselect from '@riophae/vue-treeselect'
    import SideBar from '@/components/element/sideBar'
    // import the styles
    import '@riophae/vue-treeselect/dist/vue-treeselect.css'
    import district from '@/common/district.json'
    import {getShopTypes} from '@/api/marketing'
    import {getAreaManageList} from "@/api/areamanage";
    import {
        getItemsList,
        setItemsTemplate,
        setItemsCategory,
        deleteItems,
        getItemWarningStore,
        getCategory,
        setItemsSort,
        updateGoodsInfo,
        getGoodsPrice,
        updateGoodsPrice,
        syncBatchPrice,
        updateItemRebateConf,
        getTagList,
        itemsRelTags,
        tagSearchItem,
        updateItemsStore,
        updateItemsStatus,
        updateItemsStockSyncStatus,
        getGoodsAttr,
        savebatchGoodsPricesApi,
        getDownloadList,
        deltags,
        correctionStore,
        getItemQRcode,
        getVipItemsList,
        changVipItemsPrice,
        updateOneVipItems,
    } from '@/api/goods'

    export default {
        components: {
            Treeselect,
            SideBar
        },
        props: ['getStatus'],
        provide() {
            return {
                refresh: this.getGoodsList
            }
        },
        data () {
            return {
                // 选择的商品个数
                goodsNum:0,
                // 批量类型
                price_mode:'formula',
                // 修改后的价格
                newPrice:'',
                // 算法
                newPrice2:'',
                // 大区调价
                // office_area_name:'',
                office_area_id:'',
                // office_area_all:{value:'0',name:'全平台'},
                new_office_area:[],
                office_area_param:{},

                CategoryList:[],
                current_goods_price:0,
                districtId:'0',
                stock:'',
                is_open:true,
                price_type_direct_sel:'',
                price_type_formula_sel:'',
                price_type_main_sel:'',
                algorithmVal:1,
                algorithm:[{value:1,name:'乘'},
                    {value:2,name:'除'},
                    {value:3,name:'加'},
                    {value:4,name:'减'},
                ],
                login_type: 'default',
                show_rebate_sideBar: false,
                select_regions_value: [],
                select_category_value: [],
                select_tags_value: [],
                select_branch_value:[],

                sku_list: [
                    {value: 'false', name:'多规格统一展示'},
                    {value: 'true', name:'多规格分开展示'},
                ],
                popularizeSetting: {
                    popularize_ratio: {
                        type: 'profit'
                    }
                },
                regions: district,
                current: '',
                currentbn: '',
                currentId: '',
                currentPrice: '',
                currentPriceChange: '',
                vipnowprice:'',
                tabList: [
                    {name: "全部商品", value: null, activeName: 'first'},
                    {name: "vip优惠商品", value: 'true', activeName: 'second'},
                ],
                goodsName: '',
                isEdit: false,
                activeName: 'first',
                ItemsList: [],
                vipItemList:[],
                item_id: [],
                goods_id: [],
                templates_id: '',
                templates_new_id: '',
                templatesList: [],
                category_id: [],
                categoryList: [],
                show_sideBar: false,
                loading: false,
                skuLoading: false,
                submitLoading: false,
                batchsubmitLoading:false,
                total_count: 0,
                viptotal_count:0,
                warning_store: 5,
                goodsBranchList:[],
                goodsBranchParams: {
                    page: 1,
                    pageSize: 1000,
                    attribute_type: 'brand',
                    attribute_name:''
                },
                tag: {
                    dialog: false,
                    dialogdel: false,
                    editItem: [],
                    list: [],
                    form: {
                        tag_ids: [],
                        item_ids: []
                    },
                    currentTags: [],
                    tags: []
                },
                params: {
                    page: 1,
                    pageSize: 20,
                    item_type: 'normal',
                    templates_id: '',
                    keywords: '',
                    category: 0,
                    is_warning: false,
                    tag_id: '',
                },
                vipparams:{
                    page: 1,
                    pageSize: 20,
                },
                start_date: '',
                end_date: '',
                addTemplatesdialogVisible: false,
                addCategorydialogVisible: false,
                currency: {},
                cursymbol: '￥',
                form: {},
                specItems: [],
                rebateSpecItems: [],
                grade: [],
                vipGrade: [],
                storeUpdate: false,
                batchGoodsPricesView:false,
                storeItemsList: [],
                show_itemStore: false,
                updateBatchList: [],
                show_batchStore: false,
                show_batchPrice: false,
                shop_type_list: [],
                shop_type_list_default:[
                    {label:'未选择',value:'-1'},
                    {label:'怡康自营（药）店',value:'-2'},
                ],
                default_shop_type_value:'未选择',
                itemstore: 0,
                deltaglist:[],
                deltags:'',
            }
        },
        computed: {
            ...mapGetters([
                'wheight'
            ])
        },
        methods: {

            handleClick (tab, event) {
                this.params.page = 1

                if(this.activeName == 'first') {

                    this.getGoodsList()
                }
                if(this.activeName == 'second'){
                    this.getVipGoodsList()
                }

            },

            handleCurrentChange (page_num) {
                this.params.page = page_num
                this.getGoodsList()
            },
            handleCurrentChangeVip (page_num){
                this.vipparams.page = page_num
                this.getVipGoodsList()
            },
            handleSizeChange (pageSize) {
                this.params.page = 1
                this.params.pageSize = pageSize
                this.getGoodsList()
            },
            handleChangeTemplates (val) {
                this.currentPage = 1
                this.params.templates_id = val
                this.getGoodsList()
            },
            handleSelectionChange (val) {
                let item_id = []
                for (let i in val) {
                    item_id.push(val[i].itemId)
                }
                this.item_id = item_id
                let goods_id = []
                for (let i in val) {
                    goods_id.push(val[i].goods_id)
                }
                this.goods_id = goods_id
            },
            handleCancelLabelsDialog() {
                this.tag.dialog = false
            },

            handleCancelLabelsDialogdel() {
                this.tag.dialogdel = false
                this.deltaglist=this.tag.list
                console.log(this.tag.list)
            },
            // 编辑单个店铺单个商品会员价
            editVipprice(row){
                updateOneVipItems({"vip_price":row.vip_price,"id":row.id}).then(response => {
                  //this.getVipGoodsList()
                    if(response.data.data.status) {
                        this.$message({
                            message: '修改成功',
                            type: 'success',
                            duration: 2 * 1000
                        })
                    }else{
                        this.$message({
                            message: '修改失败',
                            type: 'error',
                            duration: 2 * 1000
                        })
                    }
                })
            },


            sku_disable(){
                if(this.params.is_sku == "true"){
                    this.$message({ message: '多规格分裂展示不可编辑商品', type: 'error', duration: 2 * 1000 })
                    return false;
                }else{
                    return true;
                }
            },
            handleRebateConf(data) {
                this.show_rebate_sideBar = true
                this.show_sideBar = false
                this.skuLoading = true
                this.current = data
                getItemsList({page:1, pageSize:1000, is_sku:true, item_id:data.item_id, item_type: 'normal'}).then(res => {
                    var rebateSpecItems = []
                    res.data.data.list.forEach(item => {
                        if (item.rebate_conf.length === 0 ) {
                            item.rebate_conf = {}
                            item.rebate_conf.type = 'money'
                            item.rebate_conf.value = {}
                            // for( var key in this.popularizeSetting.popularize_ratio.profit ) {
                            //     item.rebate_conf.value[key] = ''
                            // }
                        } else {
                            // if (this.popularizeSetting.popularize_ratio.type != item.rebate_conf.ratio_type && item.rebate_conf.type != 'money') {
                            //     for( var key in this.popularizeSetting.popularize_ratio.profit ) {
                            //         item.rebate_conf.value[key] = ''
                            //     }
                            // }
                        }
                        item.rebate_conf.item_id = item.item_id
                        rebateSpecItems.push(item)
                    })
                    this.rebateSpecItems = rebateSpecItems
                    this.skuLoading = false
                })
            },
            handleBatchStore(data) {
                if(!this.sku_disable()){
                    return false
                }
                this.show_rebate_sideBar = false
                // this.show_sideBar = true
                this.show_batchStore = true
                this.current = data.item_id
                this.currentbn = data.item_bn
                this.current_goods_price = data.price
                this.getBatchData(data.item_id)
            },

            handleBatchPrice(data){
                this.show_rebate_sideBar = false
                // this.show_sideBar = true
                this.show_batchPirce = true
                this.current = data.item_id
            } ,
            getOfficeArea(){
                getAreaManageList({'format_flag':true}).then(response => {
                    this.params.page = 1;
                    this.new_office_area =response.data.data;
                })

            } ,
            handleOfficeChange:function (val){
                var now_office_area_pid = val[0]
                if(val.length > 1){
                    var now_office_area_id = val[1]
                }else{
                    var now_office_area_id = 0
                }
                this.office_area_id  = now_office_area_id
                this.office_area_pid = now_office_area_pid
            },

            getBatchData(item_id){
                this.skuLoading = true
                this.updateBatchList[''] = '';
                getShopTypes().then(res => {
                    this.shop_type_list  = res.data.data.list
                })
                this.skuLoading = false
            },
            getGoodsPrice(item_id) {
                this.skuLoading = true
                getGoodsPrice(item_id).then(res => {
                    let specItems = []
                    let colConfigs = []
                    res.data.data.list.forEach(item => {
                        specItems.push({
                            item_id: item.item_id,
                            item_spec_desc: item.item_spec_desc || item.itemName,
                            price: item.price/100,
                            grade: this.generatePrice(item.memberGrade.grade),
                            vipGrade: this.generatePrice(item.memberGrade.vipGrade),
                            distributors_prices_arr: item.distributors_prices_arr,
                        })
                    })
                    this.grade = this.generatePrice(res.data.data.list[0].memberGrade.grade)
                    this.vipGrade = this.generatePrice(res.data.data.list[0].memberGrade.vipGrade)
                    this.specItems = specItems
                    this.skuLoading = false
                })
            },
            generatePrice(data) {
                let list = []
                for (let key in data) {
                    list.push({
                        vip_grade_id: data[key].vip_grade_id,
                        grade_name: data[key].grade_name,
                        mprice: data[key].mprice/100 || '',
                    })
                }
                return list
            },
            syncPrice(item_id){
                // 同步商品价格 暂时不考虑多规格价格
                // 增加大区id
                var now_office_area_id = this.office_area_id
                var now_office_area_pid = this.office_area_pid
                // var now_office_area_name = this.office_area_name
                var price = this.currentPriceChange
                let param = {
                    item_id: item_id,
                    price: price,
                    now_office_area_id:now_office_area_id,
                    now_office_area_pid:now_office_area_pid,
                    distributor_number: this.districtId,
                }
                this.batchsubmitLoading = true

                const _self = this
                console.log(this.specItems)
                if(this.specItems.length>1){
                    this.$message({
                        type: 'error',
                        message: '多规格商品暂不支持批量同步价格',
                        duration: 1500,
                        onClose() {
                            _self.batchsubmitLoading = false
                        }
                    })
                    return false;
                }

                syncBatchPrice(param).then(res => {
                    if(res.data.data.status === true){
                        this.$message({
                            type: 'success',
                            message: '更新成功同步了'+ res.data.data.number + '店铺',
                            duration: 2000,
                            onClose() {
                                _self.batchsubmitLoading = false
                                _self.currentPriceChange = ''
                            }
                        })
                    }else{
                        this.$message({
                            type: 'error',
                            message: '更新失败',
                            duration: 2000,
                            onClose() {
                                _self.batchsubmitLoading = false
                            }
                        })
                    }
                    // 刷新页面
                    this.getGoodsList()
                }).catch(res => {
                    console.log("errr")
                    this.batchsubmitLoading = false
                })
            } ,
            goodsSearch2 () {

                if(this.activeName == 'first') {
                    this.params.page = 1
                    this.getGoodsList()
                }else{
                    this.vipparams.page = 1

                    this.getVipGoodsList()
                }
            },
            goodsSearch () {
                this.params.page = 1
                this.getGoodsList()
            },
            getGoodsList () {
                this.loading = true
                getItemsList(this.params).then(response => {
                    this.ItemsList = response.data.data.list
                    this.ItemsList.forEach(item => {
                        item.price = item.price/100
                        item.link = `pages/item/espier-detail?gid=${item.goods_id}&id=${item.item_id}`
                    })
                    this.total_count = response.data.data.total_count
                    this.warning_store = response.data.data.warning_store
                    this.loading = false
                })
            },
            getVipGoodsList(){
                this.loading = true
                this.vipparams.item_name = this.params.keywords
                this.vipparams.item_bn = this.params.item_bn
                getVipItemsList(this.vipparams).then(response => {

                   this.vipItemList = response.data.data.list

                   this.vipItemList.forEach(item => {
                        item.vip_price = item.vip_price/100
                   })

                   this.viptotal_count = response.data.data.total_count
                   this.loading = false
                })
            },

            priceformatter(row, column) {
                return this.cursymbol + row.price / 100;
            },
            rebateformatter(row, column) {
                return this.cursymbol + row.rebate / 100;
            },
            getTaskTime (strDate) {
                let date = new Date(strDate)
                let y = date.getFullYear()
                let m = date.getMonth() + 1
                m = m < 10 ? ('0' + m) : m
                let d = date.getDate()
                d = d < 10 ? ('0' + d) : d
                let str = y+"-"+m+"-"+d
                return str
            },
            getTimeStr (date) {
                return this.getTaskTime(new Date(parseInt(date) * 1000))
            },

            // getGoodsBranchList () {
            //     this.loading = true
            //     getGoodsAttr(this.goodsBranchParams).then(response => {
            //         this.goodsBranchList = response.data.data.list
            //     })
            // },
            getCategory() {
                getCategory({is_show:false}).then(response => {
                    this.categoryList = response.data.data
                })
            },
            batchItemsStore () {
                this.storeItemsList = []
                if(this.item_id.length) {
                    this.storeUpdate = true
                } else {
                    this.$message({
                        type: 'error',
                        message: '请选择至少一个商品'
                    })
                }
            },
            batchGoodsPrices () {
                this.storeItemsList = []
                if(this.item_id.length) {
                    this.goodsNum = this.item_id.length
                    this.batchGoodsPricesView = true
                } else {
                    this.$message({
                        type: 'error',
                        message: '请选择至少一个商品'
                    })
                }
            },
            batchItemsStatus (status) {
                if (this.goods_id.length === 0) {
                    this.$message({
                        type: 'error',
                        message: '请选择至少一个商品'
                    })
                    return  false
                }
                this.skuLoading = true
                let params = {}
                if (this.goods_id.length > 0) {
                    let data = []
                    this.goods_id.forEach(goods_id => {
                        data.push({goods_id: goods_id})
                    })
                    params = {
                        'items': JSON.stringify(data),
                        'status': status
                    }
                }
                this.submitLoading = true
                updateItemsStatus(params).then(res => {
                    if (res.data.data.status) {
                        this.$message({
                            message: '修改成功',
                            type: 'success',
                            duration: 2 * 1000
                        })
                        this.getGoodsList()
                    }
                    this.submitLoading = false
                    this.skuLoading = false
                })
            },
            updateItemStatus (items) {
                if(!this.sku_disable()){
                    return false
                }
                this.loading = true
                let params = {}
                params = {
                    'items': [{"goods_id":items.goods_id}],
                    'status': items.approve_status === 'instock' ? 'onsale' : 'instock'
                }
                updateItemsStatus(params).then(res => {
                    if (res.data.data.status) {
                        this.$message({
                            message: '操作成功',
                            type: 'success',
                            duration: 2 * 1000
                        })
                        this.getGoodsList()
                    }
                })
                this.loading = false
            },
            updateItemStockSyncStatus (items) {
                if(!this.sku_disable()){
                    return false
                }
                this.loading = true
                let params = {}
                params = {
                    'items': [{"goods_id":items.goods_id}],
                    'status': items.stock_sync_status === true ? 0 : 1
                }
                updateItemsStockSyncStatus(params).then(res => {
                    if (res.data.data.status) {
                        this.$message({
                            message: '操作成功',
                            type: 'success',
                            duration: 2 * 1000
                        })
                        this.getGoodsList()
                    }
                })
                this.loading = false
            },
            updateItemsStore (items) {
                if(!this.sku_disable()){
                    return false
                }
                this.skuLoading = true
                this.item_id = []
                let param = JSON.parse(JSON.stringify(this.params))
                param.item_id = items.item_id
                param.is_sku = true
                this.storeItemsList = []
                getItemsList(param).then(response => {
                    let list = response.data.data.list
                    let data = {}
                    list.forEach(item => {
                        let data = {
                            item_id: item.item_id,
                            store: item.store,
                            item_spec_desc: item.item_spec_desc ? item.item_spec_desc : item.item_name
                        }
                        this.storeItemsList.push(data)
                    })
                    this.skuLoading = false
                })
                this.show_itemStore = true
            },
            saveSynscVipPrice(){
                let paramsArr = {}
                paramsArr = {
                    'distributor_number': this.districtId,
                    'shop_type_id':this.params.shop_type_id,
                    'item_id':this.current,
                    'vip_price':this.vipnowprice,
                    'office_area_id':this.office_area_id,
                    'office_area_pid':this.office_area_pid,
                }
                // 店铺类型和区域只能选中一个
                if(this.default_shop_type_value != '未选择' && this.office_area_pid){
                    alert('店铺类型和区域只能选中一个!');
                    return false;
                }
                if( this.default_shop_type_value == '未选择' && !this.office_area_pid  && this.districtId == 0){
                    alert('请选择店铺!');
                    return false;
                }
                changVipItemsPrice(paramsArr).then(response => {
                    // let status = response.data.data.status
                    var messInfo = response.data.data.msg;
                    var messtype = response.data.data.status ? 'success' : 'error';
                    this.$message({
                        type: messtype,
                        message: messInfo
                    });
                })
            },
            saveItemsStore(){
                this.skuLoading = true
                let params = {}
                if (this.storeItemsList.length > 0) {
                    params = {
                        'items': JSON.stringify(this.storeItemsList)
                    }
                } else if (this.item_id.length > 0) {
                    let data = []
                    this.item_id.forEach(itemid => {
                        data.push({item_id: itemid, store: this.itemstore, is_default: true})
                    })
                    params = {
                        'items': JSON.stringify(data)
                    }
                }
                this.submitLoading = true
                const _self = this
                updateItemsStore(params).then(res => {
                    if (res.data.data.status) {
                        this.$message({
                            message: '修改成功',
                            type: 'success',
                            duration: 2 * 1000
                        })
                    }
                    this.submitLoading = false
                    this.skuLoading = false
                    this.storeUpdate = false
                })
            },
            // 批量导出数据
            download(){
                this.params.is_sku=true;
                this.params.item_type='normal';
                getDownloadList(this.params).then(res => {
                    if (res.data.status) {
                        this.$message({
                            message: '已添加到队列',
                            type: 'success',
                            duration: 2 * 1000
                        })
                    }
                })
            }
        },
        mounted () {
            this.login_type = this.$store.getters.login_type
            if (this.$route.query.category) {
                this.params.category = this.$route.query.category
            }
            this.params.main_cat_id = this.$route.query.main_cat_id
            if (this.$route.query.approve_status) {
                this.params.approve_status =  this.$route.query.approve_status
            }
            // getPopularizeSetting().then(response => {
            //     this.popularizeSetting = response.data.data
            // })
            if (this.$route.query.tab) {
                this.activeName = this.$route.query.tab
                this.params.is_warning = true
            }
            this.getOfficeArea()
            this.getGoodsList()
            // this.getCategory()
            // this.getGoodsBranchList()
        },

    }
</script>
<style scoped lang="scss">
  .el-row {
    margin-bottom: 20px;
    &:last-child {
      margin-bottom: 0;
    }
    img {
      width: 90%;
    }
  }
  .el-col {
    border-radius: 4px;
  }
  .bg-purple-dark {
    background: #99a9bf;
  }
  .bg-purple {
    background: #d3dce6;
  }
  .bg-purple-light {
    background: #e5e9f2;
  }
  .grid-content {
    border-radius: 4px;
    min-height: 10px;
    img {
      width: 90%;
    }
  }
  .row-bg {
    padding: 10px 20px;
    background-color: #f9fafc;
  }
  .service-label .el-checkbox:first-child{
    margin-left: 15px;
  }
  .service-label .el-input:first-child{
    margin-left: 15px;
  }
  .grid-detail {
    max-height: 300px;
    overflow-y: scroll;
    margin-bottom: 20px;
  }
  .el-carousel {
    width: 375px;
  }
  .tag-users {
    padding-bottom: 10px;
    line-height: 1.2;
    .icon-user-circle1 {
      margin-right: 10px;
      font-size: 24px;
      color: #ccc;
    }
  }
  .selected-tags {
    padding-top: 15px;
    margin-bottom: 15px;
    border-top: 1px solid #efefef;
    border-bottom: 1px solid #efefef;
    .label {
      margin-bottom: 15px;
    }
    .el-tag {
      margin-right: 10px;
      margin-bottom: 15px;
    }
  }
  .tag-item {
    cursor: pointer;
    color: #666;
    border-color: #dadadd;
    margin-right: 10px;
    margin-top: 10px;
  }
  .copy-btn {
    position: relative;
    [class^="copy-link"] {
      position: absolute;
      left: 0;
      top: 0;
      right: 0;
      bottom: 0;
      visibility: hidden;
    }
  }
</style>
<style lang="scss">
  .grid-detail {
    table, .detail-content-wrap, .detail-content-item {
      width: 100%!important;
    }
    img {
      width: 100%;
    }
  }
  .grid-attribute {
    table {
      width: 100%!important;
    }
  }
  .batch_price .el-col{
    padding-left: 5px;
    padding-right: 5px;
    display: flex;
    justify-content: center;
    align-items: center;

  }
  .pri-inp  .el-input__inner{
    padding: 1.18rem;
    height: 28px;
    line-height: 28px;
    width: 9rem;
  }
  .pri-tag{
    magin:0 8rem;
    width:3rem;
  }
  span.price-content {
    display: flex;
    margin-left: 2rem;
    line-height: 1.5rem;
    color: #101010;
  }
</style>



// WEBPACK FOOTER //
// vipitemlist.vue?76000504